var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_38853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 28.5H36V7.5H0V28.5ZM34.8746 27.45H1.12544V8.55H34.8886L34.8746 27.45Z",
    fill: "#171C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6128 20.885H7.28166V13.0264H4.64502V22.9737H11.6128V20.885Z",
    fill: "#171C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9031 18.7058V17.2943C20.9031 14.6235 19.3833 13.0264 16.8386 13.0264C14.2938 13.0264 12.774 14.6235 12.774 17.2943V18.7058C12.774 21.3766 14.2938 22.9737 16.8386 22.9737C19.3833 22.9737 20.9031 21.3766 20.9031 18.7058ZM16.8386 20.9591C15.856 20.9591 15.4107 20.2433 15.4107 18.6793V17.3208C15.4107 15.7568 15.856 15.041 16.8386 15.041C17.8211 15.041 18.2664 15.7568 18.2664 17.3208V18.6793C18.2664 20.2433 17.8211 20.9591 16.8386 20.9591Z",
    fill: "#171C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1776 22.9737V15.06H31.3546V13.0264H22.0643V15.06H25.2413V22.9737H28.1776Z",
    fill: "#171C22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_38853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLot);
export default __webpack_public_path__ + "static/media/lot.e4166d3593fb5119e534aa9c06e71ff3.svg";
export { ForwardRef as ReactComponent };